import { useLazyGetTrucksQuery, useRemoveTruckMutation } from "features/api/truckApi.ts";

export const useTrucks = () => {
	const [
		deleteTruck,
		{ error: deleteTruckError, isLoading: deleteTruckLoading, isSuccess: deleteTruckSuccess, reset: resetTruck }
	] = useRemoveTruckMutation();
	const [trucksTrigger, { data: trucks, isFetching: isTrucksLoading }] = useLazyGetTrucksQuery();
	return {
		deleteTruck,
		deleteTruckError,
		deleteTruckLoading,
		deleteTruckSuccess,
		isTrucksLoading,
		trucks,
		trucksTrigger,
		resetTruck
	};
};
